import { iconNames } from '@zapier/design-system';
export const showMoreConfig = {
    name: 'ShowMoreSection',
    category: 'Zapier Sections',
    includeScrollTracking: true,
    image: 'https://cdn.zappy.app/1f12333425c2e6e912f7ac00242f7468.png',
    canHaveChildren: true,
    inputs: [
        {
            name: 'showMoreText',
            type: 'string',
            defaultValue: 'See more',
        },
        {
            name: 'showLessText',
            type: 'string',
            defaultValue: 'See less',
        },
        {
            name: 'showMoreIcon',
            type: 'string',
            enum: ['', ...Object.keys(iconNames)],
            defaultValue: 'formAdd',
        },
        {
            name: 'showLessIcon',
            type: 'string',
            enum: ['', ...Object.keys(iconNames)],
            defaultValue: 'formDash',
        },
        {
            name: 'color',
            type: 'string',
            enum: ['danger', 'primary', 'primary-alt', 'secondary', 'tertiary'],
            defaultValue: 'secondary',
        },
        {
            name: 'hasShowLessTopButton',
            type: 'boolean',
            defaultValue: true,
        },
        {
            name: 'hasShowLessBottomButton',
            type: 'boolean',
            defaultValue: true,
        },
    ],
};
//# sourceMappingURL=config.js.map